import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomApprovalModal from "@/shared/components/custom-modal";
import PathPickInlineNotice from "@/features/pathpick/components/ui/PathPickInlineNotice";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { SMARTSTORE_API_GUIDE_URL } from "@/features/pathpick/features/basket/constants";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const STEP_KEYS = ["step_1", "step_2", "step_3", "step_4"];

// 스마트스토어 판매자센터에서 API 연동을 어떻게 켜는지 알려주는 안내 모달.
// 판매자ID만 입력해서는 연동이 되지 않는다 — API 사용 설정과 대행사 추가까지 마쳐야 하므로
// 순서를 번호로 끊어 보여준다.
function PathPickBasketApiSyncGuideModal({ isOpen, onClose }: Props) {
  const { t } = useI18nHelper();

  const handleOpenOfficialGuide = () => {
    window.open(SMARTSTORE_API_GUIDE_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      // 화면보다 넓으면 왼쪽이 스크롤로도 닿지 않아 화면 폭으로 클램프한다.
      minWidth={"min(560px, 92dvw)"}
      isCentered={true}
    >
      <CustomApprovalModal.Header
        onClose={onClose}
        title={t("path_pick:basket.buyer_info.api_guide.title")}
      />
      <CustomApprovalModal.Body>
        <Flex flexDirection={"column"} gap={"12px"}>
          <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
            {t("path_pick:basket.buyer_info.api_guide.description")}
          </Text>
          <Flex flexDirection={"column"} gap={"8px"}>
            {STEP_KEYS.map((key, index) => (
              <Flex
                key={key}
                gap={"10px"}
                alignItems={"center"}
                padding={"10px 12px"}
                borderRadius={"8px"}
                border={"0.5px solid #D4D4D1"}
                background={"#FFFFFF"}
              >
                <Flex
                  alignItems={"center"}
                  justifyContent={"center"}
                  width={"24px"}
                  height={"24px"}
                  flexShrink={0}
                  borderRadius={"50%"}
                  background={"#F0F6FF"}
                >
                  <Text textStyle={"caption-bold"} color={"#1272EF"}>
                    {index + 1}
                  </Text>
                </Flex>
                <Text textStyle={"body-sm-medium"} color={"#444440"}>
                  {t(`path_pick:basket.buyer_info.api_guide.${key}`)}
                </Text>
              </Flex>
            ))}
          </Flex>
          <PathPickInlineNotice tone={"blue"}>
            {t("path_pick:basket.buyer_info.api_guide.notice")}
          </PathPickInlineNotice>
          <Text
            textStyle={"body-sm-bold"}
            color={"#1272EF"}
            width={"fit-content"}
            cursor={"pointer"}
            textDecoration={"underline"}
            onClick={handleOpenOfficialGuide}
          >
            {t("path_pick:basket.buyer_info.api_guide.official_link")}
          </Text>
          {/* 닫기 버튼만 필요해서 공용 Footer(취소 버튼 고정 노출) 대신 직접 렌더한다. */}
          <Flex justifyContent={"flex-end"}>
            <AppButton variant={"primary"} width={"80px"} onClick={onClose}>
              <Text textStyle={"body-sm-bold"}>
                {t("path_pick:basket.buyer_info.api_guide.confirm")}
              </Text>
            </AppButton>
          </Flex>
        </Flex>
      </CustomApprovalModal.Body>
    </CustomApprovalModal>
  );
}

export default PathPickBasketApiSyncGuideModal;
